/**
 * Footer activo: barra compacta igual a https://sgc.gov.co/sismos
 *
 * Para volver al footer institucional completo:
 * 1) En este archivo, comentar el return activo y usar el de abajo, O
 * 2) En App.js: import SiteFooter from "./components/SiteFooter.Institutional";
 *
 * El markup/estilos institucionales están en:
 *   SiteFooter.Institutional.jsx
 *   SiteFooter.Institutional.css
 */
import React from "react";
import "./SiteFooter.css";

// Texto exacto del footer de sismos (bundle SGC)
const SISMOS_FOOTER_TEXT =
  "Dirección Diagonal 53 No.34-53 - Bogotá D.C Colombia. - Línea de atención Servicio Geológico Colombiano (601)2000200";

function SiteFooter() {
  return (
    <footer className="site-footer" aria-label="Pie de página">
      <p className="site-footer__text">{SISMOS_FOOTER_TEXT}</p>
    </footer>
  );
}

export default SiteFooter;

/*
 * ---------------------------------------------------------------------------
 * FOOTER INSTITUCIONAL ANTERIOR (desactivado)
 * Conservado en SiteFooter.Institutional.jsx — no borrar.
 * ---------------------------------------------------------------------------
 *
 * import SiteFooterInstitutional from "./SiteFooter.Institutional";
 * export default SiteFooterInstitutional;
 */
